import { Component, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { Formio } from 'formiojs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Guid } from 'guid-typescript';
import { FormioExport } from 'formio-export';

@Component({
  selector: 'app-auda-component',
  templateUrl: './auda.component.html'
})
export class AudaComponent {
    formSpec: any;
    formData: any;
    formId = Guid.create().toJSON().value;
    router: Router;
    httpClient: HttpClient;
    baseUrl: string;
    appService: AppService;
    ngxLoader: NgxUiLoaderService;
    jsonDataUrl: string;
    constructor(httpClient: HttpClient, router: Router, @Inject('BASE_URL') baseUrl: string, appService: AppService, ngxLoader: NgxUiLoaderService, private route: ActivatedRoute) {
      this.router = router;
      this.httpClient = httpClient;
      this.baseUrl = baseUrl;
      this.appService = appService;
      this.ngxLoader = ngxLoader;
      this.route.queryParamMap
        .subscribe(params => {
          this.jsonDataUrl = params.get('jsonUrl')
      });
    }

    ngOnInit(){
      var formData;
      var httpClient = this.httpClient;
      var baseUrl = this.baseUrl;
      var that = this;
      var jsonDataUrl = this.jsonDataUrl;
      var formId = this.formId;

      var formComponents = [
        {
          "type": "radio",
          "label": "Agreement with intro",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "agreementWIthIntro",
          "persistent": true,
          values: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Complainant name",
          "key": "complainantName",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "ABN/ACN",
          "key": "abn",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "button",
          "label": "Check",
          "key": "check",
          "disableOnInvalid": false,
          "input": true,
          "tableView": true,
          "action": "custom",
          "custom": "window.onCheck(data.abn)"
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "ABN is valid",
          "inputMask": "",
          "key": "abnValidText",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true,
          "customClass": "abnSuccess",
          "conditional": {
            "json": {
              "==": [
                {
                  "var": "data.displayabnValidationSuccess"
                },
                true
              ]
            }
          }
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "ABN is not valid",
          "inputMask": "",
          "key": "abnNotValidText",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true,
          "customClass": "abnFailure",
          "conditional": {
            "json": {
              "==": [
                {
                  "var": "data.displayabnValidationFailure"
                },
                true
              ]
            }
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Contact Person First name",
          "key": "firstName",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Contact Person Surname",
          "key": "surname",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "label": "Phone number",
          "inputMask": "(99) 9999-9999",
          "tableView": true,
          "persistent": true,
          "key": "contactPersonPhoneNumber",
          "type": "textfield",
          "input": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "label": "Email",
          "tableView": true,
          "key": "contactPersonEmail",
          "type": "email",
          "input": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Address 1",
          "key": "complainantAddress1",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Address 2",
          "key": "complainantAddress2",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Suburb",
          "key": "complainantSuburb",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "State",
          "key": "compainantState",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Postcode",
          "key": "complainantPostCode",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false,
            "pattern": "^[0-9]+$"
          }
        },
        {
          "type": "radio",
          "label": "Does the complainant has a representative?",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "doesComplainantHasRepresentative",
          "persistent": true,
          values: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Contact Person Name",
          "key": "complainantRepresentativeName",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesComplainantHasRepresentative"
                },
                "yes"
              ]
            }
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Address",
          "key": "complainantRepresentativeAddress",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesComplainantHasRepresentative"
                },
                "yes"
              ]
            }
          }
        },
        {
          "label": "Phone number",
          "inputMask": "(99) 9999-9999",
          "tableView": true,
          "persistent": true,
          "key": "complainantRepresentativePhoneNumber",
          "type": "textfield",
          "input": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesComplainantHasRepresentative"
                },
                "yes"
              ]
            }
          }
        },
        {
          "label": "Email",
          "tableView": true,
          "key": "complainantRepresentativeEmail",
          "type": "email",
          "input": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesComplainantHasRepresentative"
                },
                "yes"
              ]
            }
          }
        },
        // Add all the fields for complainant to respondent - start
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Respondant (domain name holder)",
          "key": "respondantName",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "ABN/ACN",
          "key": "respondantAbn",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "button",
          "label": "Check",
          "key": "checkRespondentBN",
          "disableOnInvalid": false,
          "input": true,
          "tableView": true,
          "action": "custom",
          "custom": "window.onCheck1(data.respondantAbn)"
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "ABN is valid",
          "inputMask": "",
          "key": "abnValidTextRespondent",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true,
          "customClass": "abnSuccess",
          "conditional": {
            "json": {
              "==": [
                {
                  "var": "data.displayabnValidationSuccessRespondent"
                },
                true
              ]
            }
          }
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "ABN is not valid",
          "inputMask": "",
          "key": "abnNotValidTextRespondent",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true,
          "customClass": "abnFailure",
          "conditional": {
            "json": {
              "==": [
                {
                  "var": "data.displayabnValidationFailureRespondent"
                },
                true
              ]
            }
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Contact Person First name",
          "key": "respondantContactPersonfirstName",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Contact Person Surname",
          "key": "respondantContactPersonSurname",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "label": "Phone number",
          "inputMask": "(99) 9999-9999",
          "tableView": true,
          "persistent": true,
          "key": "respondantContactPersonPhoneNumber",
          "type": "textfield",
          "input": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "label": "Email",
          "tableView": true,
          "key": "respondantContactPersonEmail",
          "type": "email",
          "input": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Address 1",
          "key": "respondentAddress1",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Address 2",
          "key": "respondentAddress2",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Suburb",
          "key": "respondentSuburb",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "State",
          "key": "respondentState",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Postcode",
          "key": "respondentPostCode",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false,
            "pattern": "^[0-9]+$"
          }
        },
        {
          "type": "radio",
          "label": "Does the complainant has a representative?",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "doesRespondantHasRepresentative",
          "persistent": true,
          values: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Contact Person Name",
          "key": "respondantRepresentativeName",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesRespondantHasRepresentative"
                },
                "yes"
              ]
            }
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Address",
          "key": "respondantRepresentativeAddress",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesRespondantHasRepresentative"
                },
                "yes"
              ]
            }
          }
        },
        {
          "label": "Phone number",
          "inputMask": "(99) 9999-9999",
          "tableView": true,
          "persistent": true,
          "key": "respondantRepresentativePhoneNumber",
          "type": "textfield",
          "input": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesRespondantHasRepresentative"
                },
                "yes"
              ]
            }
          }
        },
        {
          "label": "Email",
          "tableView": true,
          "key": "respondantRepresentativeEmail",
          "type": "email",
          "input": true,
          "conditional": {
            "json": {
              "===": [
                {
                  "var": "data.doesRespondantHasRepresentative"
                },
                "yes"
              ]
            }
          }
        },
        // Add all the fields for complainant to respondent - end
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Domain name in dispute",
          "key": "domainNameInDispute",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Registrar",
          "key": "registrar",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          "type": "textfield",
          "input": true,
          "tableView": true,
          "inputType": "text",
          "inputMask": "",
          "label": "Name(s), Trademark(s) or Service Mark(s) on which the complaint is based <a href='https://www.resolution.institute/documents/item/40' target='_blank'>(Sch B(3)(b)(viii))</a>:",
          "key": "trademarkServicemarkNames",
          "placeholder": "",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "defaultValue": "",
          "protected": false,
          "unique": false,
          "persistent": true,
          "validate": {
            "required": true,
            "customPrivate": false
          }
        },
        {
          type: "select",
          label: "Complainant seeks a Panel of:",
          key: "noOfPanel",
          placeholder: "Select one",
          data: {
            values: [
              { value: 'one', label: 'One' },
              { value: 'three', label: 'Three' }
            ]
          },
          "validate": {
            "required": true
          },
          dataSrc: "values",
          defaultValue: '',
          template: "<span>{{ item.label }}</span>",
          input: true
        },
        {
          "type": "radio",
          "label": "Has complaint been served on Respondent?",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "hasCompaintBeenServedOnRespondant",
          "persistent": true,
          values: [
            { value: 'yes', label: 'Yes' },
            { value: 'no', label: 'No' }
          ]
        },
        {
          "type": "htmlelement",
          "input": false,
          "tableView": true,
          "content": "Declaration: I hereby declare that:",
          "inputMask": "",
          "key": "declarationText",
          "prefix": "",
          "suffix": "",
          "multiple": false,
          "protected": false,
          "unique": false,
          "persistent": true
        },
        {
          "type": "radio",
          "label": "The Information provided in this application is, to the best of my knowledge, accurate and truthful",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "accurateAndTruthful",
          "persistent": true,
          values: [
            { value: 'yes', label: 'I Agree' },
            { value: 'no', label: 'I Disagree' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "radio",
          "label": "I have the authority to complete this Application as the Applicant or Applicant’s Representative",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "authorityToComplete",
          "persistent": true,
          values: [
            { value: 'yes', label: 'I Agree' },
            { value: 'no', label: 'I Disagree' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "radio",
          "label": "The complaint be submitted for decision in accordance with the\u00A0.auDRP\u00A0Policy, Rules and Supplemental Rules",
          "input": true,
          "inline": true,
          "tableView": false,
          "key": "inAccordanceWithauDRPPolicy",
          "persistent": true,
          values: [
            { value: 'yes', label: 'I Agree' },
            { value: 'no', label: 'I Disagree' }
          ],
          "validate": {
            "required": true
          }
        },
        {
          "type": "button",
          "label": "Submit",
          "key": "submit",
          "disableOnInvalid": false,
          "input": true,
          "tableView": false
        }
      ];

      Formio.createForm(document.getElementById('formio'), {
            "components": formComponents
        }).then(function(form){
          formData = form;
          
          if (jsonDataUrl != undefined) {
            httpClient.get<any>(that.baseUrl+ 'api/SampleData/GetJsonData?filepath=' + jsonDataUrl).subscribe(data1 => {
              form.submission = {
                data: data1
              }
            })
          } else {
            formData.submission ={data: {...formData.submission.data, ...{formId: formId}, ...{formName: 'auda'}}}
          }

          form.on('submit', function(form: any) {
            var serviceResponse = that.appService.getUrls();
            var pdfUrl = "/documents/" + formId +".pdf";
            var pdfData = {
              "key": AppService.generatedPdfKey,
              "url": []
            };
            let today = new Date();
            pdfData.url.push(pdfUrl);
            serviceResponse.push(pdfData);
            form.data.submission_date = today.toString();
            //form.data.files_submitted = this.appService.getUploadedFilesString();
            var jsonToServer = { ...form.data, ...{ files: serviceResponse } };
            
            let jsonToServer_ = JSON.parse(JSON.stringify(jsonToServer))

            today.setHours(0, 0, 0, 0);
            let newComponent = {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "Date Submitted",
              "key": "submission_date",
              "placeholder": "",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "Test_Default",
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "===": [
                    {
                      "var": "data.submission_date"
                    },
                    "yes"
                  ]
                }
              }
            };
            
            //let filesComponent = {
            //  "type": "textfield",
            //  "input": true,
            //  "tableView": true,
            //  "inputType": "text",
            //  "inputMask": "",
            //  "label": "Files Submitted",
            //  "key": "files_submitted",
            //  "placeholder": "",
            //  "prefix": "",
            //  "suffix": "",
            //  "multiple": false,
            //  "defaultValue": "Test_Default",
            //  "protected": false,
            //  "unique": false,
            //  "persistent": true,
            //  "conditional": {
            //    "json": {
            //      "===": [
            //        {
            //          "var": "data.files_submitted"
            //        },
            //        "yes"
            //      ]
            //    }
            //  }
            //};
            //this.formComponents.unshift(<any>filesComponent);
            formComponents.unshift(<any>newComponent);
            let component = {
              type: 'form',
              title: 'Resolution Institute Quickfiles application',
              display: 'form',
              components: [{
                "title": "Form details",
                "key": "panel",
                "type": "panel",
                "components": formComponents
              }]
            };

            let submission = {
              //owner: jsonToServer_.formName,
              //_id: formId,
              //modified: today.toString(),
              data: jsonToServer
            };

            let options = {
              ignoreLayout: true
            };

            let exporter = new FormioExport(component, submission, options);

            let config = {
              download: false,
              filename: formId + '.pdf'
            };

            /*
            exporter.toPdf(config).then((pdf) => {
              // download the pdf file
              pdf.save(config.filename);
            });
            */

            exporter.toPdf(config).then((pdf) => {
              return pdf.output('datauristring');
            }).then((datauri_base64) => {
              if (datauri_base64) {
                // console.log(datauri_base64);

                var pdfObject = {};
                pdfObject["base64file"] = datauri_base64;
                pdfObject["filename"] = config.filename;

                that.httpClient.post<any>(that.baseUrl + 'api/SampleData/SaveToPdf', pdfObject).subscribe(result => {
                  if (result) {
                    console.log('PDF uploaded!!');

                    that.httpClient.post<any>(that.baseUrl + 'api/SampleData/PostFormData', jsonToServer).subscribe(result => {
                      if (result) {
                        console.log('Form data uploaded!!');

                        that.router.navigateByUrl('/thankyou');
                      }
                      else {
                        alert('There was an error with the submision, please try again. -1');

                        return false;
                      }
                    }, error => {
                      console.error(error);

                      return false;
                    });
                  }
                  else {
                    alert('There was an error with the submision, please try again. -2');

                    return false;
                  }
                }, error => {
                  console.error(error);

                  return false;
                });
              }
            }).catch(function (error) {
              alert('There was an error with the submision, please try again. -3');

              return false;
            });

          });
        });
        // this.formData = {
        //     data: {
        //       "formName": "AUDA"
        //       // "lastName": "Mikkili"
        //     }
        //   };
        (window as any).onCheck = function onCheck(abnVal: any){
          that.ngxLoader.start();
          formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: false}, ...{displayabnValidationFailure: false}}}
        // console.log("abnVal is" + abnVal);
        // console.log("form is", formData);
        httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
          if(result.ABRPayloadSearchResults.response.businessEntity) {
              formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: true}, ...{displayabnValidationFailure: false}}}
          } else {
              formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: false}, ...{displayabnValidationFailure: true}}}
          }
          that.ngxLoader.stop();
      });
      };
      
      (window as any).onCheck1 = function onCheck1(abnVal: any){
          that.ngxLoader.start();
          formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: false}, ...{displayabnValidationFailureRespondent: false}}}
        // console.log("abnVal is" + abnVal);
        // console.log("form is", formData);
        httpClient.get<any>(baseUrl + 'api/SampleData/FindABN?searchText='+abnVal).subscribe((result: any) => {
          if(result.ABRPayloadSearchResults.response.businessEntity) {
              formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: true}, ...{displayabnValidationFailureRespondent: false}}}
          } else {
              formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccessRespondent: false}, ...{displayabnValidationFailureRespondent: true}}}
          }
          that.ngxLoader.stop();
      });
      };
    }
    onSubmit(event: any) {
        console.log(event.data);
        // var dataToPost = JSON.stringify(event.data);
        this.httpClient.post<any>(this.baseUrl + 'api/SampleData/PostFormData', event.data).subscribe(result => {
          if (result) {
            console.log('the form data is submitted to queue')
          this.router.navigateByUrl('/auda-thankyou');
          } else {
            console.log('form is not saved');
          }
        }, error => {
          console.error(error)
          // display a message that the form is not saved
        });
      }
}
